import { Alert, AlertDescription, AlertIcon, Skeleton } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import {
  date as commonDate,
  utils as commonUtils,
} from '@finley-technologies/common';

import { useGetFinancialCovenantCalculationsQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { parseFinancialCovenantsFromAllCovenants } from './utils';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { createFinancialCovenantsChartConfig } from 'packages/portfolio/ui/covenants/CovenantsContainer';
import { FinancialCovenantChartTemplate } from 'packages/portfolio/ui/covenants/FinancialCovenantChartTemplate';

const startDate = commonDate.currentDateTime().minus({ months: 6 }).toMillis();
const endDate = commonDate.currentEpochMs();

export const FinancialCovenantsContainerV2: React.FC<{}> = () => {
  const { creditFacilityId } = useCreditFacilityContext();
  const {
    data: covenantData,
    loading: covenantLoading,
  } = useGetFinancialCovenantCalculationsQuery({
    variables: {
      creditFacilityId,
      startDate,
      endDate,
    },
  });

  if (
    covenantLoading ||
    !covenantData ||
    !covenantData.financialCovenantCalculations
  ) {
    return (
      <Skeleton height="600px" data-testid="credit-agreements-route-loading" />
    );
  }

  const {
    config: financialCovenantsConfig,
  } = parseFinancialCovenantsFromAllCovenants({
    allCovenantData: covenantData,
  });

  if (financialCovenantsConfig.length === 0) {
    return (
      <Alert status="info" mt="20px">
        <AlertIcon />
        <AlertDescription>No financial covenants configured</AlertDescription>
      </Alert>
    );
  }

  return (
    <>
      {_.map(financialCovenantsConfig, (config) => {
        const { key, valueType } = config;
        return (
          <FinancialCovenantChartTemplate
            creditFacilityId={creditFacilityId}
            chartTitle={commonUtils.toTitleCase(key)}
            covenantKey={key}
            chartConfig={createFinancialCovenantsChartConfig(valueType)}
            key={`financial-covenant-chart-${key}`}
          />
        );
      })}
    </>
  );
};
